<template>
  <div class="flex flex-1 flex-col justify-end w-full">
    <div class="progress" v-show="loginLoading">
      <div class="progress-bar-indeterminate"></div>
    </div>
    <div class="flex flex-col md:flex-row flex-1 justify-center items-center md:items-end">
      <img class="self-center" width="50" src="../assets/img/nfc_logo.svg">
      <span class="self-center ml-4">Bring your card near NFC reader</span>
    </div>
    <input ref="nfc" placeholder="Please input" @keyup="nfcLogin" @blur="focusOnNfc" v-model="nfc" name="nfc" type="text" style="position: absolute; top: -1000px;" />
    <el-button type="default" @click="login">Switch to Login</el-button>
    <div class="bg-red-400 p-4 mt-4 text-white rounded" v-show="loginError">
      {{ loginError }}
    </div>
    <p class="self-end text-gray-400 mt-8 text-sm">&copy; 2020 Toate drepturile rezervate</p>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import axios from 'axios'

export default {
  name: 'Nfc',
  data: () => {
    return {
      nfc: null,
      loginError: null,
      loginLoading: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('click', this.focusOnNfc)
      this.focusOnNfc()
    })
  },
  methods: {
    login () {
      this.$router.push({name: 'login'})
    },
    focusOnNfc () {
      this.$refs.nfc.focus()
    },
    nfcLogin (event) {
      if(event.type != 'keyup' || event.keyCode != 13) return;

      event.preventDefault()
      this.loginError = null
      this.loginLoading = true
      axios.post(process.env.VUE_APP_API_URL + 'auth/nfc', {
        nfc: this.nfc
      })
      .then(({ data }) => {
        this.nfc = ''
        let to = ''
        if (data.role === 1) {
          to = process.env.VUE_APP_URL_ADMIN
        } else if (data.role === 2) {
          to = process.env.VUE_APP_URL_MANAGER
        } else if (data.role === 3) {
          to = process.env.VUE_APP_URL_EMPLOYEE
        } else if (data.role === 4) {
          to = process.env.VUE_APP_URL_STAFF
        } else if (data.role === 5) {
          to = process.env.VUE_APP_URL_CASHIER
        }

        localStorage.setItem('lastLoginMethod', 'nfc')
        Cookies.set('lastLoginMethod', 'nfc', { domain: process.env.VUE_APP_COOKIE_DOMAIN })
        Cookies.set('token', data.access_token, {domain: process.env.VUE_APP_COOKIE_DOMAIN})
        Cookies.set('token_type', data.token_type, {domain: process.env.VUE_APP_COOKIE_DOMAIN})
        Cookies.set('role', data.role, {domain: process.env.VUE_APP_COOKIE_DOMAIN})
        Cookies.set('token_expires_in', data.expires_in, {domain: process.env.VUE_APP_COOKIE_DOMAIN})
        window.location.href = to
      })
      .catch((err) => {
        this.nfc = ''
        this.loginLoading = false
        this.loginError = err.response.data.message
      }) 
    }
  },
  beforeDestroy () {
    window.removeEventListener('click', this.focusOnNfc)
  }
}
</script>
